export default __webpack_public_path__ + "static/media/level-box.b7082e2a.png";